/**
 * Function for instantiating and dispatching a JavaScript CustomEvent for
 * signaling that an overlay has loaded within a given page.
 */
export const dispatchOverlayLoad = (overlay) => {
    try {
        // instantiate a CustomEvent with an eventType of “overlayLoad”
        const event = new CustomEvent('overlayLoad', {
            detail: {
                // set the value of the function’s overlay parameter to
                // a “overlay” property on the CustomEvent’s detail object
                overlay
            }
        });

        document.body.dispatchEvent(event);
    } catch (e) {
        // handle exceptions as needed
    }
};



// WEBPACK FOOTER //
// ./src/components/ModalCTA/utils.js